import type { EmployeeProfile } from '@/types/employeeProfile';
import type { CreateEmployeeData } from '@/types/employees';
import type { User } from '@/types/user';

import { getStoredToken } from './apiClient';
import { ApiError, authenticatedRequest } from './base.service';

/**
 * Employees Service
 * Handles all employee-related API endpoints from /api/v1/employees/*
 */

export const employeesService = {
  /**
   * Get comprehensive employee profile
   */
  async getEmployeeProfile(
    employeeId: string,
    organizationId?: string
  ): Promise<EmployeeProfile> {
    const token = getStoredToken();
    if (!token) throw new ApiError('No authentication token found', 401);

    const query = organizationId
      ? `?organization_id=${encodeURIComponent(organizationId)}`
      : '';

    return authenticatedRequest<EmployeeProfile>(
      `/api/v1/employees/${employeeId}/profile${query}`,
      {},
      token
    );
  },

  /**
   * Create a new employee
   */
  async createEmployee(data: CreateEmployeeData): Promise<User> {
    const token = getStoredToken();
    if (!token) throw new ApiError('No authentication token found', 401);

    return authenticatedRequest<User>(
      '/api/v1/employees',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      token
    );
  },
};
